import { render } from "./ProjectStatistic.vue?vue&type=template&id=ee41af76&scoped=true&ts=true"
import script from "./ProjectStatistic.vue?vue&type=script&lang=ts"
export * from "./ProjectStatistic.vue?vue&type=script&lang=ts"

import "./ProjectStatistic.vue?vue&type=style&index=0&id=ee41af76&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee41af76"]])

export default __exports__